// extracted by mini-css-extract-plugin
export var clickThrough = "_yk-2";
export var fallback = "_yk-5";
export var frame = "_yk-3";
export var frameCell = "_yk-1";
export var overlay = "_yk-4";
export var wrapper = "_yk-0";